<template>
    <v-app>
        <Header/>
        <v-content>
            <router-view/>
        </v-content>
    </v-app>
</template>

<style scoped>
</style>

<script>
    import Header from "./layouts/Header"

    export default {
        components: {Header}
    }
</script>
